<template>
    <div class="input-wrap" :class="{error: field.validation.error, disabled: disabled}">
        <div class="label-wrap">
            <label :for="field.name">{{label}}<span v-if="field.validation.required">*</span></label>

            <div class="toggle">
                <a href="" :class="{selected : valMatchesCV}" @click.prevent="selectCV" v-if="valMatchesCV != null" :title="cvMatchTitle">CV</a>
                <a href="" :class="{selected : valMatchesSF}" @click.prevent="selectSF" v-if="valMatchesSF != null" :title="sfMatchTitle">SF</a>
            </div>
        </div>
        <input :id="field.name" :type="type" :attr="inputProps"
               :class="{changed:field.initialValue !== field.value}"
               v-model="field.value" v-mask="field.mask" :placeholder="field.placeholder" @blur="validate()" @change="this.change" autocomplete="off"/>
        <div class="error">{{field.validation.error}}</div>
    </div>
</template>

<script>
    export default {
        name: 'InputField',
        props: [
            'field',
            'type',
            'label',
            'inputProps',
            'disabled',
            'src'
        ],
        computed: {
            valMatchesCV() {
                if(this.field && this.src && this.src.cv != null) {
                    return this.field.value === this.src.cv;
                }
                return null;
            },
            valMatchesSF() {
                if(this.field && this.src && this.src.sf != null) {
                    return this.field.value === this.src.sf;
                }
                return null;
            },
            cvMatchTitle(){
                if(this.valMatchesCV){
                    return 'This value matches the CV';
                } else {
                    return 'Replace with value from CV';
                }
            },
            sfMatchTitle(){
                if(this.valMatchesSF){
                    return 'This value matches the Salesforce record';
                } else {
                    return 'Replace with value from Salesforce';
                }
            }
        },
        methods: {
            change() {
                this.$emit('onChange', this.field);
            },
            validate() {
                this.field.value = this.field.value.trim();
                this.field.validate()
            },
            selectCV() {
                this.field.value = this.src.cv;
            },
            selectSF() {
                this.field.value = this.src.sf;
            }
        }
    };
</script>

<style scoped>
    
    .label-wrap {display: flex; justify-content: space-between;}
        .label-wrap > * {align-self: flex-end;}
    
        .toggle > a {font-size: .7rem; font-weight: bold; text-transform: uppercase; margin-bottom: .25rem; /*border-bottom: solid 1px var(--colour-primary);*/ text-decoration: none; display: inline-block; transition: .25s;}
        .toggle > a + a {margin-left: .3rem;}
        .toggle > a.selected:hover {cursor: default;}
        .toggle > a:not(.selected) {color: #000; border-bottom: solid 1px transparent; opacity: .25;}
        .toggle > a:not(.selected):hover {border-bottom: solid 1px #000;}

    .changed { background-color: #93c57a; }
    
</style>